import styled from 'styled-components';

export const TextInputContainer = styled.div`
  width: 100%;
  position: relative;
`;
